import { useEffect, useState } from "react"
import {
  getPvpRouletteRuntimeRevision,
  subscribePvpRouletteRuntime,
} from "@/shared/lib/pvp-roulette-runtime/runtime"

/** Перерисовка при `setPvpRouletteRuntimePatch` / `resetPvpRouletteRuntime`. */
export function usePvpRouletteRuntimeRevision(): number {
  const [n, setN] = useState(() => getPvpRouletteRuntimeRevision())
  useEffect(
    () =>
      subscribePvpRouletteRuntime(() => setN(getPvpRouletteRuntimeRevision())),
    []
  )
  return n
}
